import React from 'react';

import { useAppDispatch, useAppSelector } from '../../../hooks/customHooks';
import { SIcon, STitle, SWrapper } from '../styles/DocTypeListItem.styled';
import { setActiveDocType } from '../../../features/docTypesSlice';
import { IDocTypeDto } from '../../../api/client';
import { faCheck } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

interface IProps {
  docType: IDocTypeDto;
}

const DocTypeListItem: React.FC<IProps> = ({ docType }) => {
  const activeDocType = useAppSelector((state) => state.docTypes.activeDocType);
  const dispatch = useAppDispatch();
  const isActive = docType.name === activeDocType?.name;

  return (
    <SWrapper active={isActive} className="hoverable--darker" onClick={() => dispatch(setActiveDocType(docType))}>
      <STitle>{docType.name}</STitle>
      {isActive ? (
        <SIcon>
          <FontAwesomeIcon icon={faCheck} />
        </SIcon>
      ) : null}
    </SWrapper>
  );
};

export default DocTypeListItem;
